import React from "react";
import TextField from "@mui/material/TextField";
import FormControl from "@mui/material/FormControl";
import InputAdornment from "@mui/material/InputAdornment";

export default function InputField({ register, ...props }) {
  return (
    <FormControl fullWidth>
      <TextField
        {...register}
        sx={{
          "& .MuiOutlinedInput-root:hover": {
            "& > fieldset": {
              borderColor: props.hoverColor,
            },
          },
          "& fieldset": {
            borderColor: props.fieldsetBorderColor,
          },
        }}
        color={props.color}
        placeholder={props.placeholder}
        type={props.type}
        required={props.required}
        disabled={props.disabled}
        multiline={props.multiline}
        minRows={props.minRows}
        maxRows={props.maxRows ? props.maxRows : 10}
        size="small"
        name={props.name}
        id={props.id}
        label={props.label}
        variant={props.variant ? props.variant : "outlined"}
        value={props.value}
        defaultValue={props.defaultValue}
        onChange={props.onChange}
        InputProps={{
          style: props.style,
          // disableUnderline: props.disableunderline,
          inputProps: {
            min: props.minNumbValue,
            max: props.maxNumbValue,
          },
          startAdornment: (
            <InputAdornment position="start">
              {props.startAdornment}
            </InputAdornment>
          ),
          endAdornment: (
            <InputAdornment position="end">{props.endAdornment}</InputAdornment>
          ),
        }}
      />
    </FormControl>
  );
}
